module.exports = __webpack_public_path__ + "assets/mixpanel.b8f0a7cf.svg";